// Apple-Inspired Design System Theme

const lightTheme = {
  name: "light",
  body: "#FBFBFD",
  bodySecondary: "#F5F5F7",
  text: "#1D1D1F",
  secondaryText: "#86868B",
  tertiaryText: "#A1A1A6",
  accentColor: "#0071E3",
  accentBright: "#0077ED",
  accentCyan: "#0284C7",
  accentPurple: "#8944AB",
  accentGreen: "#248A3D",
  accentOrange: "#D97706",
  accentGlow: "rgba(0, 113, 227, 0.15)",
  projectCard: "rgba(255, 255, 255, 0.8)",
  cardBorder: "rgba(0, 0, 0, 0.08)",
  cardHoverBorder: "rgba(0, 113, 227, 0.3)",
  cardShadow:
    "0 10px 30px -10px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.03)",
  cardHoverShadow:
    "0 20px 40px -15px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 113, 227, 0.2)",
  imageDark: "#F5F5F7",
  imageClothes: "#E5E5EA",
  avatarMisc: "#E5E5EA",
  avatarShoes: "#D1D1D6",
  tagBg: "rgba(0, 113, 227, 0.06)",
  tagText: "#0071E3",
  tagBorder: "rgba(0, 113, 227, 0.15)",
  headerBg: "rgba(251, 251, 253, 0.8)",
  glassBg: "rgba(255, 255, 255, 0.75)",
  badgeBg: "#F5F5F7",
  pillBg: "rgba(0, 0, 0, 0.04)",
  pillBorder: "rgba(0, 0, 0, 0.08)",
};

export const themes = { light: lightTheme };
